import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { AuraMark, AuraWordmark } from "@/components/AuraMark";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { Hammer, LogIn, LogOut } from "lucide-react";

const GOLD = "#C8A15C";

export default function UnderConstruction() {
  const nav = useNavigate();
  const { user, logout } = useAuth();

  return (
    <div data-testid="under-construction-page" className="min-h-screen flex items-center justify-center px-6"
      style={{ background: "#050507" }}>
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{ backgroundImage: "radial-gradient(circle at 20% 30%, #C8A15C 0, transparent 45%), radial-gradient(circle at 80% 70%, #B0863C 0, transparent 45%)" }} />
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="relative max-w-lg w-full text-center">
        <div className="flex items-center justify-center gap-3 mb-8">
          <AuraMark className="w-10 h-10" />
          <AuraWordmark className="text-xl" />
        </div>
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border mb-7"
          style={{ borderColor: "rgba(200,161,92,0.3)", background: "rgba(200,161,92,0.08)" }}>
          <Hammer className="w-3.5 h-3.5" style={{ color: GOLD }} />
          <span className="label-mono text-xs" style={{ color: GOLD }}>PRE-LAUNCH</span>
        </div>
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl text-white leading-tight">
          We're tuning the room.
        </h1>
        <p className="text-base text-[#A1A1AA] mt-5 leading-relaxed">
          AuraSession is putting the finishing touches on the session engine. We'll open the doors to
          producers shortly. Thanks for your patience.
        </p>

        {user ? (
          <div className="mt-9 space-y-3">
            <p className="text-sm text-[#71717A]">
              Signed in as <span className="text-[#E4E4E7]">{user.email}</span>. Your account will have full
              access the moment we launch.
            </p>
            <Button data-testid="uc-logout-btn" onClick={logout} variant="ghost"
              className="rounded-full text-[#A1A1AA] hover:text-white">
              <LogOut className="w-4 h-4 mr-2" /> Sign out
            </Button>
          </div>
        ) : (
          <div className="mt-9">
            <Button data-testid="uc-team-signin-btn" onClick={() => nav("/login")}
              className="rounded-full font-semibold px-6" style={{ background: GOLD, color: "#0D0E12" }}>
              <LogIn className="w-4 h-4 mr-2" /> Team sign in
            </Button>
            <p className="text-xs text-[#52525B] mt-3">Admins and the launch team can sign in to preview.</p>
          </div>
        )}
      </motion.div>
    </div>
  );
}
